import { render, staticRenderFns } from "./WeixinJSPay.vue?vue&type=template&id=9387caa2&scoped=true"
import script from "./WeixinJSPay.vue?vue&type=script&lang=js"
export * from "./WeixinJSPay.vue?vue&type=script&lang=js"
import style0 from "./WeixinJSPay.vue?vue&type=style&index=0&id=9387caa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9387caa2",
  null
  
)

export default component.exports